import * as React from 'react';

import Image from 'next/future/image';
import Link from 'next/link';

import ByLine from '@/components/pages/frontpage/components/Feature/Middle/ByLine';
import type { ArticleType } from '@/types/ArticleType';
import decodeEntities from '@/utils/functions/string/decodeEntities';
import slugify from '@core/utils/functions/slugify';

type FeaturedProps = {
    article: ArticleType;
};

const Featured = (props: FeaturedProps) => {
    const { article } = props;
    const { excerpt, slug, primaryCategory, title, authors, imageUrl, publishedAtTimestamp } = article;

    return (
        <div className="flex flex-col justify-center items-start self-stretch gap-3">
            <div className="flex flex-col justify-start items-start self-stretch gap-2">
                <div className="flex justify-start items-center relative gap-1">
                    <p>
                        <Link href={`/category/${slugify(decodeEntities(primaryCategory))}`} passHref>
                            <a className="text-primary text-xs uppercase">{decodeEntities(primaryCategory)}</a>
                        </Link>
                    </p>
                </div>
                <div className="gap-2.5 font-headline">
                    <Link href={`/news/${slug}`}>
                        <a className="flex-grow text-2xl md:text-3xl xl:text-4xl leading-snug hover:text-primary">
                            {decodeEntities(title)}
                        </a>
                    </Link>
                </div>
                <div className="gap-2.5">
                    <p className="text-gray-500">{excerpt}</p>
                </div>
                <ByLine authors={authors} publishedAtTimestamp={publishedAtTimestamp} className="mt-2 text-xs" />
                <div className="mt-0.5">
                    <Link href={`/news/${slug}`} passHref>
                        <a className="cursor-pointer">
                            <Image
                                src={imageUrl}
                                width={768}
                                height={432}
                                sizes="(min-width: 75em) 80vw, (min-width: 48em) 100vw"
                                decoding="async"
                                className="w-full"
                                alt="article-image"
                                priority
                            />
                        </a>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Featured;
